import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { RenderNavItem } from "../components/RenderNavItem";
import { HealthServicesLeftMenuList } from "../utils/constants";

const Health_Ambulances = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
          <div className="container">
            <div className="section-main-heading2">
              <h4 className="fontSizeClass"> </h4>
            </div>
          </div>
        </div>
      </section>
      {/* End Slider */}
      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu  min-height-400">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {HealthServicesLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2 bas">
                    <h3 className="fontSizeClass"> {t("Ambulance")}</h3>
                  </div>
                  <div className="health-dept-table" style={{ width: "100%" }}>
                    <table
                      width="95%"
                      border={0}
                      align="center"
                      cellPadding={2}
                      cellSpacing={2}
                      className="table table-bordered officials"
                    >
                      <tbody>
                        <tr
                          bgcolor="#302ba0"
                          tabIndex={0}
                          align="center"
                          valign="middle"
                        >
                          <td width="7%" className="text-white tble-brder-left">
                            {t("Sl.No")}.
                          </td>
                          <td width="33%" className="text-white">
                            {t("Borough")}
                          </td>
                          <td
                            width="12%"
                            className="text-white tble-brder-right"
                          >
                            {t("No. of Ambulance")}
                          </td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td width="7%" align="center">
                            1
                          </td>
                          <td width="33%" align="center">
                            {t("Borough")} I to X
                          </td>
                          <td width="12%" align="center">
                            12
                          </td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td width="7%" align="center">
                            2
                          </td>
                          <td width="33%" align="center">
                            {t("Borough")} - XI
                          </td>
                          <td width="12%" align="center">
                            1
                          </td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td width="7%" align="center">
                            3
                          </td>
                          <td width="33%" align="center">
                            {t("Borough")} - XII
                          </td>
                          <td width="12%" align="center">
                            1
                          </td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td width="7%" align="center">
                            4
                          </td>
                          <td width="33%" align="center">
                            {t("Borough")} - XIV
                          </td>
                          <td width="12%" align="center">
                            1
                          </td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td width="7%" align="center">
                            5
                          </td>
                          <td width="33%" align="center">
                            {t("Borough")} - XV
                          </td>
                          <td width="12%" align="center">
                            1
                          </td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td width="7%" align="center">
                            6
                          </td>
                          <td width="33%" align="center">
                            {t("Borough")} - XVI
                          </td>
                          <td width="12%" align="center">
                            1
                          </td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td width="7%" align="center">
                            7
                          </td>
                          <td width="33%" align="center">
                            {t("KMC HQ")}
                          </td>
                          <td width="12%" align="center">
                            1
                          </td>
                        </tr>
                        <tr>
                          <td width="7%" align="center"></td>
                          <td width="33%" tabIndex={0} align="center">
                            <b>
                              {t("Total")} <br />
                            </b>
                          </td>
                          <td width="12%" tabIndex={0} align="center">
                            <b>
                              {t("18(Running)")}
                              <b />
                            </b>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Health_Ambulances;
